const fileGroups = [
	{ text: '', key: null, value: null },
	{ text: '', key: 'text.fileGroups.tender', value: 0 },
	{ text: '', key: 'text.fileGroups.online', value: 1 },
	{ text: '', key: 'text.fileGroups.schedule', value: 2 },
	{ text: '', key: 'text.fileGroups.entries', value: 3 },
	{ text: '', key: 'text.fileGroups.infos', value: 4 },
	{ text: '', key: 'text.fileGroups.else', value: 5 },
	{ text: '', key: 'text.fileGroups.live', value: 6 },
	{ text: '', key: 'text.fileGroups.results', value: 7 },
	{ text: '', key: 'text.fileGroups.moreLA', value: 8 },
	{ text: '', key: 'text.fileGroups.elseLA', value: 9 },
	{ text: '', key: 'text.fileGroups.liveOwner', value: 16 },
	{ text: '', key: 'text.fileGroups.resultsOwner', value: 17 },
];

function getFileGroups(_this, remove) {
	fileGroups.forEach((x) => {
		if (x.key != null) x.text = _this.$t(x.key);
	});
	return fileGroups.filter(x => !remove.includes(x.value));
}

export default getFileGroups;
